<template>
  <div class="details">
    <el-dialog
      title="| 链接分享"
      :visible.sync="dialogVisible"
      width="580px"
      :before-close="handleClose">
      <span>我的链接：</span>
      <input type="text" class="link-share" v-model="message"/>
      <button
        v-clipboard:copy="message"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        class="copy"
      >复 制</button>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="visible"
      center
      width="380px"
      height="300px"
      :before-close="handleClose">
      <el-dialog
        class="dia-title"
        title="填写信息让您的专属客服帮您"
        :visible.sync="dialog"
        center
        append-to-body
        width="690px"
        height="460px">
        <div class="message">
          <el-form :model="form" ref="formModifyRow" :rules="rules">
            <el-form-item :rules="{required: true, message: '不能为空', trigger: ['blur', 'change']}" prop="enterpriseName">
              <el-input
                v-model="form.enterpriseName"
                placeholder="企业名称（必填）"
                class="message-inp"
              ></el-input>
            </el-form-item>
            <el-form-item prop="name" :rules="{required: true, message: '不能为空', trigger: ['blur', 'change']}">
              <el-input
                v-model="form.name"
                placeholder="姓名（必填）"
                class="message-inp"
              ></el-input>
            </el-form-item>
            <el-form-item prop="telephone" :rules="[{required: true, message: '请输入手机号', trigger: ['blur', 'change']},
                {pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '格式不正确'}]">
              <el-input
                v-model="form.telephone"
                placeholder="联系电话（必填）"
                class="message-inp"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="message-btn"  @click="submitRow()">立即提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <div class="lack">当前积分为 <span>{{score.currentScore}}</span> 积分不足</div>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="dialog = true">我要购买</el-button>
      </span>
    </el-dialog>
    <div class="box">
      <div class="box-t com-title">
        积分商城
        <div @click="share(detail.linkUrl)" class="shareText">
          <div>分享</div>
          <img src="../../assets/images/read.png"/>
        </div>
      </div>
      <div class="head">
        <div class="head-left">
          <img :src="detail.productPics"/>
        </div>
        <div class="head-right">
          <div class="head-title">
            <div class="hot-btn">热门</div>
            <span>{{detail.title}}</span>
          </div>
          <div class="price">
            <span>积分</span>
            <span class="prier">{{detail.exchangeScore}}</span>
            <span>市场价</span>
            <span class="priers">¥ {{detail.minMarketPrice}} - ¥ {{detail.maxMarketPrice}}</span>
            <div class="num">
              <span style="margin-right: 34px">数量</span>
              <el-input-number size="small" v-model="num" @change="myBuys" :min="1"
                               :max="detail.stock"></el-input-number>
              <span class="repertory">( 库存 {{detail.stock}} )</span>
              <div class="tig" v-if="num >= detail.stock">不能大于库存数量</div>
              <div v-else-if="num === undefined">不能为空</div>
              <div v-else></div>
            </div>
          </div>
          <el-button type="primary" class="pri-btn" @click="myBuy">
            积分兑换
          </el-button>
        </div>
      </div>
      <div class="tab">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="产品详情" name="first">
            <div class="pro-det" v-html="detail.details"></div>
          </el-tab-pane>
          <el-tab-pane v-if="this.caseList !== null && this.caseList.length >= 1" label="成功案例" name="second">
            <div class="pro-case">
              <template v-for="item in this.caseList">
                <router-link class="content-btn" :to="{path:'/succeed-details', query:{caseList: item}}">
                  <div class="grid-content">
                    <div class="grid-pic">
                      <img :src="item.thumbnail"/>
                    </div>
                    <div class="grid-title">
                      {{item.company}}
                    </div>
                    <div class="grid-con">{{item.title}}</div>
                    <div class="grid-foot">
                      <span v-if="item.impression !== 0">展现量：{{item.impression}}</span><span v-else></span>
                      <span v-if="item.click !== 0" style="margin-left: 20px">访问量：{{item.click}}</span><span
                      v-else></span>
                    </div>
                  </div>
                </router-link>
              </template>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
  import userApi from '@/api/system/user'
  import Api from '@/api/customer-good'
  import scoreApi from '@/api/client/task-wall'
  import { FormArgument } from '@/models/customer-good'

  export default {
    components: {},
    created () {
      this.shopGood()
      this.requestList()
      setTimeout(() => {
        this.ani()
      }, 0)
    },
    mounted () {
      window.addEventListener('scroll', this.scrollToTop)
      Api.readsh(response => {
        let status = response.status || 0
        if (status === 200 || status === 204) {
          this.$message.success('完成阅读任务')
        }
      })
    },
    data () {
      return {
        dialog: false,
        dialogVisible: false,
        visible: false,
        detail: {},
        form: new FormArgument(),
        num: 1,
        table: {
          list: []
        },
        message: '',
        caseList: [],
        score: [],
        activeName: 'first'
      }
    },
    methods: {
      share (linkUrl) {
        this.message = linkUrl
        this.dialogVisible = true
      },
      shopGood () {
        Api.productGood({id: this.$route.query.id}, response => {
          let status = response.status || 0
          let body = response.data || {}
          if (status === 200 || status === 204) {
            this.table.list = body
            this.caseList = body.list
            this.detail = this.table.list
          }
        })
      },
      requestList () {
        scoreApi.scoreList(response => {
          let status = response.data.code
          let body = response.data.data
          if (status === '200') {
            this.score = body
          } else {
            this.score = []
          }
        })
      },
      submitRow () {
        this.$refs['formModifyRow'].validate((valid) => {
          if (valid) {
            let name = this.form.name
            let enter = this.form.enterpriseName
            let phone = this.form.telephone
            if (name !== '' && name !== undefined && enter !== '' && enter !== undefined && phone !== '' && phone !== undefined) {
              let form = this.form
              form.type = 8
              form.platform = 2
              userApi.create({form: form}, response => {
                let status = response.status || 0
                let body = response.data || []
                if (status >= 200 && status <= 204) {
                  // 新数据加到数组开头
                  this.message.unshift(body)
                  this.$message.success('留言成功')
                } else {
                  this.$message.error(body.error || '留言失败')
                }
                // 关闭
                this.$refs['slideModifyRow'].close()
              })
              this.form = []
              this.dialog = false
            } else {
              this.$message.error('信息不能为空')
            }
          } else {
            return false
          }
          this.form = []
        })
      },
      myBuy () {
        let at = this.detail.exchangeScore * this.num
        let all = this.score.currentScore
        if (at <= all) {
          this.$router.push({name: 'confirm-order', params: {id: this.detail.id, num: this.num}})
        } else {
          this.visible = true
        }
      },
      myBuys () {
        let at = this.detail.stock
        if (this.num === null || this.num === undefined) {
          this.num = 1
        }
        if (at < this.num) {
          this.num = at
        }
      },
      onCopy (e) {
        this.visible = false
        Api.sharese(response => {
          let status = response.status || 0
          if (status === 200 || status === 204) {
            this.$message.success('复制成功，请把链接分享给他人' || e.text)
          } else {
            this.$message.error('分享失败')
          }
        })
      },
      onError (e) {
        this.$message.success('复制失败，请手动复制')
      }
    }
  }
</script>

<style scoped="scoped" lang="scss">
  .details {
    width: 100%;
    background: white;
    border: 1px solid #ddd;
    padding: 30px;
    box-sizing: border-box;
    margin-bottom: 50px;
    .lack{
      width: 100%;
      font-size: 14px;
      margin:0 auto;
      >span{
        color: #1770E6;
      }
    }
    .link-share{
      width: 350px;
      height: 35px;
      border-radius: 4px;
      border: 1px solid #999;
      font-size: 14px;
      text-indent: 10px;
    }
    .copy{
      width: 100px;
      height: 40px;
      border-radius: 4px;
      border: none;
      outline: none;
      color: white;
      background: #085ECC;
      cursor: pointer;
      &:hover {
        background: #4a98ff;
        transition-duration: 0.5s;
      }
    }
    .box {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      padding-bottom: 50px;
      box-sizing: border-box;
      .box-t {
        font-size: 16px;
        font-weight: bold;
        color: #085ECC;
        .shareText{
          float: right;
          margin-right: 50px;
          >div{
            font-size: 14px;
            cursor: pointer;
            float: left;
          }
          >img{
            width: 14px;
            height: 14px;
            margin:3px 0 0 5px;
            float: left;
          }
        }
      }
      .head {
        height: 284px;
        padding: 10px 0 55px 0;
        box-sizing: border-box;
        > .head-left {
          width: 280px;
          height: 210px;
          float: left;
          > img {
            width: 100%;
            height: 100%;
          }
        }
        > .head-right {
          width: 620px;
          min-height: 210px;
          float: right;
          margin-left: 5px;
          > .head-title {
            width: 80%;
            min-height: 40px;
            font-size: 18px;
            color: #333;
            word-break: break-all;
            word-wrap: break-word;
            > .hot-btn {
              width: 50px;
              height: 24px;
              border: 1px solid #3683e9;
              color: #3683e9;
              border-radius: 5px;
              margin-right: 20px;
              text-align: center;
              line-height: 24px;
              float: left;
              font-size: 14px;
            }
          }
          > .price {
            padding-top: 20px;
            box-sizing: border-box;
            height: 100px;
            clear: both;
            color: #666;
            margin-bottom: 30px;
            >.prier{
              color: #1770e6;
              font-size: 18px;
              margin:0 110px 0 34px;
            }
            >.priers{
              color: #1770e6;
              font-size: 18px;
              margin-left: 20px;
            }
            > .num {
              margin-top: 20px;
              .repertory {
                color: #999;
                font-size: 14px;
                margin-left: 10px;
              }
              .tig {
                font-size: 12px;
                margin: 5px 0 0 70px;
                color: #F56C6C;
              }
            }
          }
          .pri-btn {
            width: 180px;
            background: #1770E6;
            outline: none;
            border: none;
            font-size: 16px;
            &:hover {
              background: #4a98ff;
              transition-duration: 0.5s;
            }
          }
        }
      }
      .tab {
        clear: both;
        .pro-det {
          width: 100%;
          min-height: 890px;
          padding:36px 40px;
          box-sizing: border-box;
        }
        .pro-case {
          min-height: 890px;
          padding: 50px 0;
          box-sizing: border-box;
          .grid-content {
            width: 280px;
            height: 410px;
            margin: 15px 16px;
            border: 1px solid #eee;
            float: left;
            .grid-pic {
              width: 100%;
              height: 210px;
              > img {
                width: 100%;
                height: 100%;
              }
            }
            .grid-title {
              width: 140px;
              height: 60px;
              line-height: 60px;
              color: #333;
              font-weight: bold;
              padding-left: 20px;
              box-sizing: border-box;
            }
            .grid-con {
              width: 280px;
              height: 60px;
              overflow: hidden;
              line-height: 30px;
              color: #666;
              padding-left: 20px;
              box-sizing: border-box;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }
            .grid-foot {
              width: 100%;
              height: 60px;
              line-height: 60px;
              color: #1770e6;
              padding: 0 20px;
              box-sizing: border-box;
              margin-top: 20px;
            }
          }
        }
      }
    }
    .lack {
      width: 100%;
      font-size: 20px;
      text-align: center;
    }
  }
</style>
<style lang="scss">
  .dia-title > .el-dialog >.el-dialog__header{
    height: 70px;
    line-height: 70px;
    background: #f9f9f9;
  }
  .dia-title > .el-dialog >.el-dialog__header > .el-dialog__title{
    color: #085ECC;
    font-size: 20px;
    font-weight: bold;
  }
  .details > .box > .tab > .el-tabs > .el-tabs__header {
    margin: 0;
  }
  .dia-title{
    text-align: center;
    .message {
      padding: 45px 130px;
      box-sizing: border-box;
      .message-inp {
        width: 380px;
        height: 40px;
      }
      .message-btn {
        width: 180px !important;
        height: 40px !important;
        margin-left: 28%;
        background: #085ECC;
        &:hover{
          background: #4a98ff;
          transition-duration: 0.5s;
        }
      }
    }
  }

  .details {
    .box {
      .tab {
        .pro-det {
          img {
            width: 100%;
          }
        }
      }
    }
  }

  .tab {
    .el-tabs {
      .el-tabs__header {
        .el-tabs__nav-wrap {
          .el-tabs__nav-scroll {
            .el-tabs__nav {
              .el-tabs__item {
                background: rgba(228, 231, 237, 1);
                color: #666;
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }

  .tab {
    .el-tabs {
      .el-tabs__header {
        .el-tabs__nav-wrap {
          .el-tabs__nav-scroll {
            .el-tabs__nav {
              .is-active {
                background: #fff;
                border-bottom: 2px solid #085ECC;
                color: #085ECC;
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/client/ShoppingDetails.vue